/*
 * ANANDA FX — universal motion engine.
 *   1. Blob backdrop spawning.
 *   2. Word-by-word heading wrapping.
 *   3. Scroll-triggered element reveals.
 *   4. Wave dividers between sections.
 *   5. Marquee text bands.
 *   6. 3D-tilt cards on mouse-over.
 *   7. Magnetic buttons on mouse-over.
 */
(function () {
  if (typeof IntersectionObserver !== 'function') return;
  var canHover = window.matchMedia('(hover: hover)').matches;

  /* -------- 1. Blob backdrop -------- */
  function initBlobs() {
    if (document.querySelector('.ananda-blobs')) return;
    var c = document.createElement('div');
    c.className = 'ananda-blobs';
    c.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 5; i++) {
      var b = document.createElement('div');
      b.className = 'ananda-blob ananda-blob--' + i;
      c.appendChild(b);
    }
    document.body.insertBefore(c, document.body.firstChild);
  }

  /* -------- 2. Heading word wrapping --------
   * Splits matching headings into one <span.ananda-word> per word so the
   * reveal animation can stagger them. Has known issues with Hebrew/RTL
   * because the parts.reverse() below was an early hack — if the heading
   * wraps to multiple lines the words land in the wrong order. Until that
   * is properly rewritten, sections that need a single continuous Hebrew
   * headline can opt out by living inside a container that's added to
   * the OPT_OUT list. (Roi reported the contact-form heading rendering
   * as "שאלה לכל בשבילכם זמינים" instead of
   * "זמינים בשבילכם לכל שאלה" — fixed by opting out .contact.) */
  function wrapHeadings() {
    var selectors = [
      '.image-with-text__heading',
      '.banner__heading',
      '.rich-text__heading',
      '.featured-collection__title',
      '.featured-product__title',
      '.collection-hero__title',
      'main h1',
      'main h2.h1',
      'main h2.h2'
    ].join(',');

    // Skip per-word wrapping inside any of these ancestors. Add a class
    // here to keep its heading as one continuous text run.
    var OPT_OUT = '.contact, .ananda-events-page, .ananda-pdp-hero, .ananda-hero-section, .ananda-events-hero__title';

    var nodes = document.querySelectorAll(selectors);
    nodes.forEach(function (h) {
      if (h.dataset.anandaHeadline) return;
      if (h.querySelector('img, svg, br, a, span')) return;
      if (h.closest(OPT_OUT)) return;
      var text = h.textContent.trim();
      if (!text || text.length > 120) return;

      h.dataset.anandaHeadline = '1';
      h.setAttribute('data-ananda-headline', '');
      h.setAttribute('data-ananda-reveal', '');
      h.innerHTML = '';

      var parts = text.split(/(\s+)/);

      var wordIndex = 0;
      parts.forEach(function (part) {
        if (/^\s+$/.test(part)) {
          h.appendChild(document.createTextNode(part));
        } else {
          var span = document.createElement('span');
          span.className = 'ananda-word';
          span.style.setProperty('--word-i', wordIndex++);
          span.textContent = part;
          h.appendChild(span);
        }
      });
    });
  }

  /* -------- 4. Wave dividers -------- */
  var WAVE_PATHS = [
    'M 0,30 Q 200,8 400,30 T 800,30 T 1200,30',
    'M 0,30 Q 300,52 600,30 T 1200,30',
    'M 0,30 C 200,5 300,55 500,30 S 800,5 900,30 S 1100,55 1200,30',
    'M 0,30 Q 150,15 300,30 T 600,30 T 900,30 T 1200,30'
  ];
  function buildWaveSvg(variant) {
    var d = WAVE_PATHS[variant % WAVE_PATHS.length];
    return '<svg viewBox="0 0 1200 60" preserveAspectRatio="none" focusable="false" aria-hidden="true">' +
      '<path d="' + d + '" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round"/>' +
      '<g class="ananda-wave-divider__ornament" transform="translate(600,30)">' +
        '<line x1="-32" y1="0" x2="-18" y2="0" stroke="currentColor" stroke-width="1"/>' +
        '<line x1="18"  y1="0" x2="32"  y2="0" stroke="currentColor" stroke-width="1"/>' +
        '<circle r="9" fill="none" stroke="currentColor" stroke-width="1"/>' +
        '<circle r="3.5" fill="currentColor"/>' +
      '</g>' +
    '</svg>';
  }
  function insertDividers() {
    if (document.querySelector('.ananda-wave-divider')) return;
    var sections = document.querySelectorAll('main > .shopify-section');
    if (sections.length < 2) return;
    for (var i = 0; i < sections.length - 1; i++) {
      if (!sections[i].offsetHeight || !sections[i + 1].offsetHeight) continue;
      var d = document.createElement('div');
      d.className = 'ananda-wave-divider';
      d.setAttribute('aria-hidden', 'true');
      d.setAttribute('data-ananda-reveal', '');
      d.innerHTML = buildWaveSvg(i);
      sections[i].after(d);
    }
  }

  /* -------- 5. Marquees -------- */
  function buildMarquee(items, opts) {
    opts = opts || {};
    var classes = ['ananda-marquee'];
    if (opts.reverse) classes.push('ananda-marquee--reverse');
    if (opts.small)   classes.push('ananda-marquee--small');

    var dot = '<span class="ananda-marquee__dot">●</span>';
    function htmlFor(arr) {
      return arr.map(function (t) {
        return '<span class="ananda-marquee__item">' + t + '</span>';
      }).join(dot);
    }
    var inner = htmlFor(items) + dot + htmlFor(items) + dot;
    var el = document.createElement('div');
    el.className = classes.join(' ');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="ananda-marquee__track">' + inner + '</div>';
    return el;
  }
  function insertMarquees() {
    if (document.querySelector('.ananda-marquee')) return;
    var sections = document.querySelectorAll('main > .shopify-section');
    if (sections.length < 2) return;

    var bigItems = ['ANANDA', 'COCKTAILS', 'IN THE MOVE', 'אננדה', 'קוקטיילים בתנועה'];
    var big = buildMarquee(bigItems, {});
    sections[0].after(big);

    if (sections.length >= 3) {
      var smallItems = ['ANYTIME · ANYWHERE', '13% ABV · 250ML', 'NO GLASS · ALL VIBE', 'אנשים · חוויה · טעם'];
      var small = buildMarquee(smallItems, { reverse: true, small: true });
      sections[sections.length - 1].before(small);
    }
  }

  /* -------- 6. 3D-tilt cards -------- */
  function initTilt() {
    if (!canHover) return;
    var els = document.querySelectorAll('.product-card-wrapper, .card-wrapper, .collage__item');
    els.forEach(function (el) {
      if (el.dataset.anandaTilt === '1') return;
      el.dataset.anandaTilt = '1';
      el.classList.add('ananda-tilt');

      var rect = null;

      function enter() {
        rect = el.getBoundingClientRect();
        el.classList.add('is-tilting');
      }
      function move(e) {
        if (!rect) return;
        var x = (e.clientX - rect.left) / rect.width  - 0.5;
        var y = (e.clientY - rect.top)  / rect.height - 0.5;
        var rotY = x * 10;
        var rotX = -y * 10;
        el.style.transform =
          'perspective(1100px) rotateX(' + rotX.toFixed(2) + 'deg) rotateY(' + rotY.toFixed(2) + 'deg) translateY(-6px)';
      }
      function leave() {
        rect = null;
        el.classList.remove('is-tilting');
        el.style.transform = '';
      }

      el.addEventListener('pointerenter', enter);
      el.addEventListener('pointermove',  move);
      el.addEventListener('pointerleave', leave);
    });
  }

  /* -------- 7. Magnetic buttons -------- */
  function initMagnetic() {
    if (!canHover) return;
    // .ananda-brand-story__cta added in v4 phase 3 round 3 — Roi: "the
    // brand-story CTA should react to mouse like the hero CTA".
    var els = document.querySelectorAll(
      '.button:not(.button--secondary), ' +
      '.shopify-payment-button__button, ' +
      '.ananda-hero__cta, ' +
      '.ananda-hero__prices-btn, ' +
      '.ananda-brand-story__cta, ' +
      '.ananda-pricing__mix'
    );
    els.forEach(function (el) {
      if (el.dataset.anandaMag === '1') return;
      el.dataset.anandaMag = '1';
      el.classList.add('ananda-magnetic');

      var rect = null;

      function enter() {
        rect = el.getBoundingClientRect();
        el.classList.add('is-magnetic');
      }
      function move(e) {
        if (!rect) return;
        var x = (e.clientX - rect.left) / rect.width  - 0.5;
        var y = (e.clientY - rect.top)  / rect.height - 0.5;
        var tx = x * 14;
        var ty = y * 8 - 2;
        el.style.transform = 'translate(' + tx.toFixed(1) + 'px, ' + ty.toFixed(1) + 'px)';
      }
      function leave() {
        rect = null;
        el.classList.remove('is-magnetic');
        el.style.transform = '';
      }

      el.addEventListener('pointerenter', enter);
      el.addEventListener('pointermove',  move);
      el.addEventListener('pointerleave', leave);
    });
  }

  /* -------- 3. Tag elements for reveal and observe -------- */
  function tagRevealables() {
    var sections = document.querySelectorAll('main > .shopify-section, .shopify-section-group-footer-group .shopify-section');
    sections.forEach(function (section) {
      var els = section.querySelectorAll([
        '.card-wrapper',
        '.product-card-wrapper',
        '.collage__item',
        '.multicolumn-card',
        '.image-with-text__heading',
        '.image-with-text__text-item',
        '.image-with-text__media',
        '.banner__heading',
        '.banner__text',
        '.banner__buttons',
        '.banner__media',
        '.rich-text__heading',
        '.rich-text__text',
        '.rich-text__buttons',
        '.featured-product__title',
        '.featured-product__description',
        '.featured-product__media',
        '.featured-collection__title',
        '.collection-hero__title',
        '.collection-hero__description',
        '.grid__item',
        '.collection-list-wrapper .card'
      ].join(','));

      els.forEach(function (el, i) {
        if (el.hasAttribute('data-ananda-reveal')) return;
        el.setAttribute('data-ananda-reveal', '');
        if (el.matches('.image-with-text__media, .banner__media, .featured-product__media')) {
          el.setAttribute('data-ananda-reveal', 'zoom');
        }
        el.style.setProperty('--ananda-reveal-delay', Math.min(i * 70, 600) + 'ms');
      });
    });
  }

  function observeAll() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-ananda-revealed', '');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-ananda-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    initBlobs();
    wrapHeadings();
    insertDividers();
    // insertMarquees() — DISABLED in v4. Marquees are now real sections.
    tagRevealables();
    observeAll();
    initTilt();
    initMagnetic();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
